import { useQuery } from '@apollo/client';
import { Query } from 'graphql/generated/graphqlTypes';
import { GET_DOORS_FOR_ACCESS_EVENTS_FILTERS, GET_VISITORS_ACCESS_EVENTS_FILTERS } from 'graphql/v2/queries';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { useEffect } from 'react';
import { BaseHookProps } from '../hooks.types';

const useAccessEventsDataForFilters = ({ handleFetchError }: BaseHookProps) => {
  const { translation } = useTranslation();

  const {
    loading: doorsLoading,
    error: doorsError,
    data: doors
  } = useQuery<Pick<Query, 'getDoorsForTenant'>>(GET_DOORS_FOR_ACCESS_EVENTS_FILTERS);

  useEffect(() => {
    if (doorsError) {
      handleFetchError(translation.devices_error_fetching);
      console.error(doorsError);
    }
  }, [doorsError]);

  const {
    loading: visitorsLoading,
    error: visitorsError,
    data: visitors
  } = useQuery<Pick<Query, 'getVisitors'>>(GET_VISITORS_ACCESS_EVENTS_FILTERS);

  useEffect(() => {
    if (visitorsError) {
      handleFetchError(translation.users_error_fetching);
      console.error(visitorsError);
    }
  }, [visitorsError]);

  return {
    doors: doors?.getDoorsForTenant || [],
    doorsLoading,
    visitors: visitors?.getVisitors || [],
    visitorsLoading
  };
};

export default useAccessEventsDataForFilters;
